module.exports = __webpack_public_path__ + "static/media/NokiaPureHeadline_Bd.e1f1cdc9.ttf";